import React, { useState, useCallback, useRef } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    Progress,
    ModalFooter,
} from "reactstrap";

import { toast } from "react-toastify";
import API from "../../Network/API";
import { useDispatch } from "react-redux";
import { ADD_POST_FETCH_SUCCESS } from "../../Reducer/postReducer";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { compressVideo, formatSize, VideoTooLongError, quickValidateVideo } from "../../utils/videoCompressor";
import { searchStockSymbols } from "../../utils/renderMarkdown";

export default function PostCreateModal(props) {
    const fileObj = [];
    const fileArrayAnotherImage = [];
    const fileArrayAnother = [];
    const fileArrayVideo = [];
    const fileArray = [];
    const [isLoading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [message, setMessage] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileUrl, setFileUrl] = useState(null);
    const [files, setFile] = useState([]);
    const [fileArrayImage, setFileArray] = useState([]);
    const [post_modalDialog, setPostShareModalDialog] = useState(false);
    const [video_url, setVideoUrl] = useState('');
    const [nudityWarning, setNudityWarning] = useState("");
    const [statusText, setStatusText] = useState('');
    const [sizeInfo, setSizeInfo] = useState(null); // { original, compressed }
    const [cashtagSuggestions, setCashtagSuggestions] = useState([]);
    const [cashtagSelectedIdx, setCashtagSelectedIdx] = useState(0);
    const [cashtagQuery, setCashtagQuery] = useState('');
    const fileInput = React.useRef();
    const textareaRef = useRef(null);
    const photoInputRef = useRef(null);
    const videoInputRef = useRef(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const myArr = JSON.parse(localStorage.getItem('user_data'));
    let msgText = t('Whats on your mind') + ", " + (localStorage.getItem("profile_name") || "") + "?";

    /* ── Markdown formatting helper ── */
    const wrapSelection = (prefix, suffix) => {
        const ta = textareaRef.current;
        if (!ta) return;
        const start = ta.selectionStart;
        const end = ta.selectionEnd;
        const text = ta.value;
        const selected = text.substring(start, end);
        const before = text.substring(0, start);
        const after = text.substring(end);
        // Use suffix if explicitly provided (even empty string), else mirror prefix
        const actualSuffix = suffix !== undefined ? suffix : prefix;
        // Trim trailing whitespace from selection so **bold ** doesn't break markdown
        const trimmed = (selected || 'text').replace(/\s+$/, '');
        const trailingSpace = (selected || 'text').slice(trimmed.length);
        const wrapped = prefix + trimmed + actualSuffix + trailingSpace;
        const newValue = before + wrapped + after;
        // Update both the textarea value and React state
        ta.value = newValue;
        setMessage(newValue);
        localStorage.setItem('message', newValue);
        // Place cursor: if text was selected, after the wrapped text; if placeholder, select it
        const cursorPos = selected
            ? start + wrapped.length
            : start + prefix.length + 'text'.length;
        setTimeout(() => {
            ta.focus();
            if (selected) {
                ta.setSelectionRange(cursorPos, cursorPos);
            } else {
                // Select the placeholder "text" so user can type over it
                ta.setSelectionRange(start + prefix.length, start + prefix.length + 4);
            }
        }, 0);
    };

    const removeImage = (url, indexNumber) => {
        const index = files.indexOf(url);
        if (index > -1) { // only splice array when item is found
            files.splice(index, 1); // 2nd parameter means remove one item only
        }
        setFile([...files, files])
        removeElement(indexNumber)

    }

    const removeElement = (index) => {
        const filesf = files.filter((_, i) => i !== index);
        const filesOrginal = fileArrayImage.filter((_, i) => i !== index);
        setFile(filesf); // this array reset for display instant image showing
        setFileArray(filesOrginal); // this array reset for upload to server
    };

    const uploadHandlerSecondInput = (e) => {
        setSelectedFile(e.target.files[0]);
        setFileUrl(URL.createObjectURL(e.target.files[0]))
        fileObj.push(e.target.files)
        for (let i = 0; i < fileObj[0].length; i++) {
            let extn = e.target.files[i].name.split('.').pop();

            if (extn.toLowerCase() === 'mp4' || extn.toLowerCase() === 'wmv' || extn.toLowerCase() === 'avi' || extn.toUpperCase() === "MKV" || extn.toUpperCase() === "WEBM" || extn.toUpperCase() === "MOV") {
                fileArrayVideo.push(URL.createObjectURL(fileObj[0][i]));

            } else {
                fileArray.push(URL.createObjectURL(fileObj[0][i]))
            }


            if (fileArrayImage.indexOf(fileObj[0][i]) === -1) {
                fileArrayAnother.push(fileObj[0][i])
            }

            if (files.indexOf(URL.createObjectURL(fileObj[0][i])) === -1) {
                fileArrayAnotherImage.push(URL.createObjectURL(fileObj[0][i]))
            }




        }

        setFileArray([...fileArrayImage, ...fileArrayAnother]) // this is for upload to server
        setFile([...files, ...fileArrayAnotherImage]) // this is for display

    }

    const uploadHandler = async (e) => {
        if (!e.target.files || e.target.files.length === 0) return;

        const newFiles = [];      // File objects for upload
        const newUrls = [];       // URLs for display

        for (let i = 0; i < e.target.files.length; i++) {
            const file = e.target.files[i];

            // Instant validation for video files
            if (file.type?.startsWith('video/') || isVideoFile(file)) {
                const validation = await quickValidateVideo(file);
                if (!validation.valid) {
                    toast.error(validation.error);
                    continue; // Skip this file, don't add it
                }
            }

            newFiles.push(file);
            newUrls.push(URL.createObjectURL(file));
        }

        if (newFiles.length === 0) return;

        setSelectedFile(newFiles[0]);
        setFileUrl(URL.createObjectURL(newFiles[0]));

        // Append to existing files instead of overwriting
        setFileArray(prev => [...prev, ...newFiles]);
        setFile(prev => [...prev, ...newUrls]);
    }


    const VIDEO_EXTENSIONS = ['MP4', 'WMV', 'AVI', 'MKV', 'WEBM', 'MOV', 'QT', 'FLV', 'OGG'];

    function isVideoFile(file) {
        const ext = file.name.split('.').pop().toUpperCase();
        return VIDEO_EXTENSIONS.includes(ext) || file.type?.startsWith('video/');
    }

    async function onCreatePost() {
        if (selectedFile === null && message === null) {
            toast.error("Post is empty");
            return false;
        }

        setLoading(true);
        setNudityWarning("");
        setProgress(0);
        setSizeInfo(null);

        try {
            // --- Separate files into images and videos ---
            const allFiles = fileArrayImage && fileArrayImage.length > 0
                ? [...fileArrayImage]
                : selectedFile != null ? [selectedFile] : [];

            const imageFiles = allFiles.filter(f => !isVideoFile(f));
            const videoFiles = allFiles.filter(f => isVideoFile(f));

            // --- Phase 1: Compress videos (0-30% progress) ---
            const compressedVideos = [];
            if (videoFiles.length > 0) {
                setStatusText('Compressing...');
                let totalOriginal = 0;
                let totalCompressed = 0;

                for (let i = 0; i < videoFiles.length; i++) {
                    const startTime = Date.now();

                    const result = await compressVideo(videoFiles[i], (p) => {
                        const base = (i / videoFiles.length) * 30;
                        const portion = (1 / videoFiles.length) * 30;
                        setProgress(Math.round(base + (p * portion)));
                    }, (msg) => {
                        console.log('Compress:', msg);
                        // Show method in status text
                        if (msg.includes('WebCodecs') && msg.includes('hardware')) {
                            setStatusText('⚡ Compressing (WebCodecs GPU)...');
                        } else if (msg.includes('WebCodecs failed')) {
                            setStatusText('🔧 Compressing (FFmpeg)...');
                        } else if (msg.includes('FFmpeg') && !msg.includes('failed')) {
                            setStatusText('🔧 Compressing (FFmpeg)...');
                        }
                    });

                    const elapsed = ((Date.now() - startTime) / 1000).toFixed(1);

                    compressedVideos.push(result.file);
                    totalOriginal += result.originalSize;
                    totalCompressed += result.compressedSize;

                    if (!result.skipped) {
                        const method = result.method === 'webcodecs' ? '⚡ WebCodecs GPU' : '🔧 FFmpeg';
                        toast.info(`${method} • ${elapsed}s • ${formatSize(totalOriginal)} → ${formatSize(totalCompressed)}`, { autoClose: 5000 });
                        setSizeInfo({
                            original: formatSize(totalOriginal),
                            compressed: formatSize(totalCompressed),
                        });
                    } else {
                        toast.info(`Video already optimal — skipped (${elapsed}s)`, { autoClose: 3000 });
                    }
                }
            }

            setProgress(30);

            // --- Phase 2: Upload (30-80% progress) ---
            setStatusText('Uploading...');
            setSizeInfo(null);

            const fd = new FormData();
            for (const img of imageFiles) {
                fd.append('image[]', img, img.name);
            }
            for (const vid of compressedVideos) {
                fd.append('video[]', vid, vid.name);
            }
            if (message !== "") {
                fd.append('details', message);
            }

            const response = await API.post("/v1/posts", fd, {
                onUploadProgress: (progressEvent) => {
                    const uploadPct = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                    // Map upload 0-100% into overall 30-80%
                    setProgress(30 + Math.round(uploadPct * 0.5));
                }
            });

            // --- Phase 3: Publish (80-100%) ---
            setStatusText('Publishing...');
            setProgress(90);

            if (response.data.success === true) {
                setProgress(100);
                toast.success(response.data.message);
                dispatch(ADD_POST_FETCH_SUCCESS(response.data.data));
                setFile([]);
                setFileArray([]);
                localStorage.setItem('message', '');
                setProgress(0);
                setStatusText('');
                setNudityWarning("");
                props.handleShowB();
            } else if (response.data.success === false) {
                toast.error(response.data.message || "Post failed");
            }
        } catch (err) {
            if (err instanceof VideoTooLongError) {
                const maxMin = Math.floor(err.maxSeconds / 60);
                toast.error(`Video is too long (max ${maxMin} minutes)`);
            } else if (err?.response) {
                const status = err.response.status;
                if (status === 422) {
                    const warningMsg = "This post might contain nudity or explicit content that violates ConnectsApp content policy.";
                    setNudityWarning(warningMsg);
                    toast.warning(warningMsg);
                } else if (status === 413) {
                    toast.error("File is too large. Maximum size is 200MB.");
                } else if (status === 500) {
                    toast.error("Server error. Please try again later.");
                } else {
                    toast.error(`Upload failed (Error ${status}). Please try again.`);
                }
            } else if (err?.code === 'ECONNABORTED') {
                toast.error("Upload timed out. Please check your connection.");
            } else {
                console.error('Post error:', err);
                toast.error("Something went wrong. Please try again.");
            }
        } finally {
            setLoading(false);
            setProgress(0);
            setStatusText('');
            setSizeInfo(null);
        }
    }

    const POST_MAX_LENGTH = 63206;

    const inputValue = (e) => {
        const val = e.target.value.slice(0, POST_MAX_LENGTH);
        setMessage(val)
        localStorage.setItem('message', val)

        // Detect cashtag typing: find $WORD at cursor position
        const ta = e.target;
        const cursorPos = ta.selectionStart;
        const textBefore = val.substring(0, cursorPos);
        const cashtagMatch = textBefore.match(/\$([A-Za-z]{1,5})$/);

        if (cashtagMatch) {
            const query = cashtagMatch[1];
            setCashtagQuery(query);
            const results = searchStockSymbols(query);
            setCashtagSuggestions(results);
            setCashtagSelectedIdx(0);
        } else {
            setCashtagSuggestions([]);
            setCashtagQuery('');
        }
    }

    // Insert selected cashtag at cursor position
    const insertCashtag = (symbol) => {
        const ta = textareaRef.current;
        if (!ta) return;
        const cursorPos = ta.selectionStart;
        const text = ta.value;
        // Find the $QUERY before cursor and replace it with $SYMBOL
        const before = text.substring(0, cursorPos);
        const after = text.substring(cursorPos);
        const cashtagMatch = before.match(/\$([A-Za-z]{1,5})$/);
        if (cashtagMatch) {
            const start = cursorPos - cashtagMatch[0].length;
            const newText = text.substring(0, start) + '$' + symbol + ' ' + after;
            ta.value = newText;
            setMessage(newText);
            localStorage.setItem('message', newText);
            const newCursorPos = start + symbol.length + 2; // after $ + symbol + space
            setTimeout(() => {
                ta.focus();
                ta.setSelectionRange(newCursorPos, newCursorPos);
            }, 0);
        }
        setCashtagSuggestions([]);
        setCashtagQuery('');
    }

    // Handle keyboard: cashtag dropdown navigation + formatting shortcuts
    const handleKeyDown = (e) => {
        // ── Cashtag dropdown active: handle arrow/enter/tab/escape ──
        if (cashtagSuggestions.length > 0) {
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                setCashtagSelectedIdx(i => Math.min(i + 1, cashtagSuggestions.length - 1));
                return;
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                setCashtagSelectedIdx(i => Math.max(i - 1, 0));
                return;
            } else if (e.key === 'Enter' || e.key === 'Tab') {
                e.preventDefault();
                insertCashtag(cashtagSuggestions[cashtagSelectedIdx].symbol);
                return;
            } else if (e.key === 'Escape') {
                setCashtagSuggestions([]);
                return;
            }
        }

        // ── Formatting shortcuts (Ctrl/Cmd + key) ──
        const mod = e.ctrlKey || e.metaKey; // Ctrl on Windows/Linux, Cmd on Mac
        if (!mod) return;

        // Ctrl+B = Bold
        if (e.key === 'b' || e.key === 'B') {
            e.preventDefault();
            wrapSelection('**');
            return;
        }
        // Ctrl+I = Italic
        if (e.key === 'i' || e.key === 'I') {
            e.preventDefault();
            wrapSelection('*');
            return;
        }
        // Ctrl+Shift+X = Strikethrough
        if ((e.key === 'x' || e.key === 'X') && e.shiftKey) {
            e.preventDefault();
            wrapSelection('~~');
            return;
        }
        // Ctrl+E = Inline code
        if (e.key === 'e' || e.key === 'E') {
            e.preventDefault();
            wrapSelection('`');
            return;
        }
        // Ctrl+Shift+Q = Quote
        if ((e.key === 'q' || e.key === 'Q') && e.shiftKey) {
            e.preventDefault();
            wrapSelection('> ', '');
            return;
        }
    }

    const handlePaste = async (e) => {
        // Handle file pastes (images)
        if (e.clipboardData.files.length) {
            const fileObject = e.clipboardData.files[0];
            setSelectedFile(fileObject);
            setFileUrl(URL.createObjectURL(fileObject))
            fileArray.push(URL.createObjectURL(e.clipboardData.files[0]))
            fileArrayAnother.push(e.clipboardData.files[0])
            fileArrayAnotherImage.push(URL.createObjectURL(e.clipboardData.files[0]))
            setFileArray([...fileArrayImage, e.clipboardData.files[0]])
            setFile([...files, URL.createObjectURL(fileObject)]) // this is for display
            return;
        }

        // Handle text pastes — detect URLs and shorten them
        const pastedText = e.clipboardData.getData('text');
        if (!pastedText) return;

        const urlPattern = /https?:\/\/[^\s<>"]+/g;
        const urls = pastedText.match(urlPattern);
        if (!urls || urls.length === 0) return;

        // Prevent default paste — we'll insert the modified text manually
        e.preventDefault();

        let modifiedText = pastedText;

        // Shorten each URL found in the pasted text
        for (const url of urls) {
            // Don't re-shorten already-shortened URLs
            if (url.includes('/s/') && url.length < 50) continue;

            try {
                const response = await API.post('/shorten-url', { url });
                if (response.data?.short_url) {
                    modifiedText = modifiedText.replace(url, response.data.short_url);
                }
            } catch (err) {
                console.warn('URL shortening failed for:', url);
                // Keep original URL if shortening fails
            }
        }

        // Insert the modified text at cursor position
        const ta = textareaRef.current;
        if (ta) {
            const start = ta.selectionStart;
            const end = ta.selectionEnd;
            const before = ta.value.substring(0, start);
            const after = ta.value.substring(end);
            const newValue = (before + modifiedText + after).slice(0, POST_MAX_LENGTH);
            ta.value = newValue;
            setMessage(newValue);
            localStorage.setItem('message', newValue);
            // Position cursor after pasted text
            const cursorPos = start + modifiedText.length;
            setTimeout(() => {
                ta.focus();
                ta.setSelectionRange(cursorPos, cursorPos);
            }, 0);
        }
    }


    const dropZoneRef = useRef(null);

    const handleDrop = (e) => {
        e.preventDefault();
        const fileObject = e.dataTransfer.files[0];

        setSelectedFile(fileObject);
        setFileUrl(URL.createObjectURL(fileObject))
        fileArray.push(URL.createObjectURL(fileObject))
        fileArrayAnother.push(fileObject)
        fileArrayAnotherImage.push(URL.createObjectURL(fileObject))
        setFileArray([...fileArrayImage, fileObject])
        setFile([...files, URL.createObjectURL(fileObject)]) // this is for display
        //   // Create a new FileReader to read the contents of the dropped image file
        //   const reader = new FileReader();

        //   reader.onload = (event) => {
        //     const imageUrl = event.target.result;
        //     const clipboardItem = new ClipboardItem({ 'image/png': imageFile });
        //     navigator.clipboard.write([clipboardItem])
        //       .then(() => console.log('Image copied to clipboard'))
        //       .catch((error) => console.error('Could not copy image to clipboard: ', error));
        //   };

        //   reader.readAsDataURL(imageFile);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    return (<>
        <Modal
            isOpen={props.isModalVisible}
            size=""
            toggle={props.handleShowB}
            onOpened={() => {
                textareaRef.current?.focus();
                setTimeout(() => textareaRef.current?.focus(), 100);
                // Resize modal when mobile keyboard appears
                if (window.visualViewport) {
                    const handler = () => {
                        const modal = document.querySelector('.post-create-modal .modal-content');
                        if (modal) {
                            modal.style.height = window.visualViewport.height + 'px';
                        }
                    };
                    window.visualViewport.addEventListener('resize', handler);
                    // Store for cleanup
                    window._postModalVVHandler = handler;
                    handler(); // apply immediately
                }
            }}
            onClosed={() => {
                if (window.visualViewport && window._postModalVVHandler) {
                    window.visualViewport.removeEventListener('resize', window._postModalVVHandler);
                    delete window._postModalVVHandler;
                }
            }}
            className={'modal-dialog-scrollable post-create-modal'}
            modalClassName={'post-create-modal-root'}
            zIndex={10050}
            backdropClassName={'post-create-modal-backdrop'}
            backdrop="static"
        >
            <ModalHeader toggle={props.handleShowB} id={'staticBackdropLabel'} className={'new-post-modal-header'}
                style={{ display: 'flex', alignItems: 'center' }}
            >
                <span>{t('Create New Post')}</span>
            </ModalHeader>
            <ModalBody style={{ display: 'flex', flexDirection: 'column', padding: '16px', minHeight: '300px' }}>
              <div style={{ flex: 1 }}>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                            <div className="image">
                                <a href="javascript:void(0)">
                                    <div className="user-picture-container rounded-circle"
                                        style={{ background: `url(${myArr.avatar})` }} />
                                </a>
                            </div>
                            <div className="info ms-2">
                                <span className="name">
                                    <a href="javascript:void(0)" className="text-dark">{myArr.name}</a>
                                </span>
                                <div className="dropdown">
                                    {/* <button
                                        className="btn btn-share_post_privacy dropdown-toggle rounded-pill border border-dark"
                                        type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown"
                                        aria-expanded="false">
                                        <i className="fa-solid fa-globe me-1" /> Everyone
                                    </button> */}
                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        <li><a className="dropdown-item" href="javascript:void(0)">Public</a></li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                        {/* Markdown formatting toolbar */}
                        <div className="md-format-toolbar">
                            <span role="button" title="Bold (Ctrl+B)" onClick={() => wrapSelection('**')} style={{ fontWeight: 700 }}>B</span>
                            <span role="button" title="Italic (Ctrl+I)" onClick={() => wrapSelection('*')} style={{ fontStyle: 'italic' }}>I</span>
                            <span role="button" title="Strikethrough (Ctrl+Shift+X)" onClick={() => wrapSelection('~~')} style={{ textDecoration: 'line-through' }}>S</span>
                            <span role="button" title="Code (Ctrl+E)" onClick={() => wrapSelection('`')} style={{ fontFamily: 'monospace', fontSize: '12px' }}>&lt;/&gt;</span>
                            <span role="button" title="Quote (Ctrl+Shift+Q)" onClick={() => wrapSelection('> ', '')}>❝</span>
                        </div>
                    </div>
                <div className="share_post_write_text" >
                    <form ref={dropZoneRef}
                        onDrop={handleDrop}
                        onDragOver={handleDragOver} onPaste={(e) => handlePaste(e)}>
                        <div className="form-group">
                            <textarea
                                ref={textareaRef}
                                name="message"
                                className="form-control write_textarea"
                                autoFocus
                                placeholder={msgText}
                                defaultValue={localStorage.getItem('message')}
                                maxLength={POST_MAX_LENGTH}
                                onChange={(e) => inputValue(e)}
                                onKeyDown={handleKeyDown}
                                onInput={(e) => {
                                    e.target.style.height = 'auto';
                                    const maxH = window.innerHeight * 0.3; // 30vh max
                                    const scrollH = e.target.scrollHeight;
                                    if (scrollH > maxH) {
                                        e.target.style.height = maxH + 'px';
                                        e.target.style.overflowY = 'auto';
                                    } else {
                                        e.target.style.height = scrollH + 'px';
                                        e.target.style.overflowY = 'hidden';
                                    }
                                    // Keep cursor visible — scroll to bottom
                                    e.target.scrollTop = e.target.scrollHeight;
                                }}
                                style={{
                                    minHeight: '100px',
                                    maxHeight: '30vh',
                                    resize: 'none',
                                    overflow: 'hidden',
                                    border: 'none',
                                    outline: 'none',
                                    boxShadow: 'none',
                                    fontSize: '16px',
                                    cursor: 'text',
                                    paddingBottom: '24px',
                                }}
                            />
                            {/* Cashtag autocomplete dropdown */}
                            {cashtagSuggestions.length > 0 && (
                                <div style={{
                                    position: 'absolute',
                                    zIndex: 1000,
                                    background: '#fff',
                                    border: '1px solid #e4e6eb',
                                    borderRadius: '8px',
                                    boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                                    maxHeight: '240px',
                                    overflowY: 'auto',
                                    width: '280px',
                                    marginTop: '4px',
                                }}>
                                    {cashtagSuggestions.map((item, idx) => (
                                        <div
                                            key={item.symbol}
                                            onClick={() => insertCashtag(item.symbol)}
                                            style={{
                                                padding: '8px 12px',
                                                cursor: 'pointer',
                                                background: idx === cashtagSelectedIdx ? '#f0f2f5' : '#fff',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                borderBottom: idx < cashtagSuggestions.length - 1 ? '1px solid #f0f2f5' : 'none',
                                                transition: 'background 0.1s',
                                            }}
                                            onMouseEnter={() => setCashtagSelectedIdx(idx)}
                                        >
                                            <span style={{ fontWeight: 700, color: '#4a90d9', minWidth: '48px' }}>${item.symbol}</span>
                                            <span style={{ color: '#65676b', fontSize: '13px', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.name}</span>
                                            <span style={{ color: '#999', fontSize: '11px', fontFamily: 'monospace' }}>{item.exchange}</span>
                                        </div>
                                    ))}
                                </div>
                            )}
                            {message.length > POST_MAX_LENGTH * 0.9 && (
                                <div className="text-end mt-1" style={{ fontSize: '12px', color: message.length >= POST_MAX_LENGTH ? '#dc3545' : '#6c757d' }}>
                                    {POST_MAX_LENGTH - message.length} characters remaining
                                </div>
                            )}
                        </div>
                    </form>

                </div>

                {/* 3-phase progress bar */}
                {progress > 0 && (
                    <div style={{ marginTop: '8px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                            <span style={{ fontSize: '13px', fontWeight: 600, color: '#555' }}>
                                {statusText && <><i className={`fas ${statusText === 'Compressing...' ? 'fa-compress' : statusText === 'Uploading...' ? 'fa-cloud-upload-alt' : 'fa-check-circle'} me-1`} />{statusText}</>}
                            </span>
                            {sizeInfo && (
                                <span style={{ fontSize: '12px', color: '#45bd62', fontWeight: 600 }}>
                                    {sizeInfo.original} → {sizeInfo.compressed}
                                </span>
                            )}
                        </div>
                        <Progress
                            value={progress}
                            color={progress >= 100 ? 'success' : progress >= 80 ? 'info' : 'primary'}
                            style={{ height: '6px', borderRadius: '3px' }}
                        />
                    </div>
                )}

                {/* Media previews */}
                {files.length > 0 && (
                    <div className="d-flex flex-nowrap overflow-auto gap-2 py-2">
                        {(fileArrayImage || []).map((url, index) => (
                            <div className="position-relative" key={index} id={window.URL.createObjectURL(url)} style={{ minWidth: '120px', maxWidth: '160px' }}>
                                {url.type?.startsWith('image/') ?
                                    <div style={{ height: '120px', borderRadius: '8px', overflow: 'hidden' }}>
                                        <img src={window.URL.createObjectURL(url)} alt="preview"
                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                    </div>
                                    : url.type?.startsWith('video/') ?
                                        <div style={{ height: '120px', borderRadius: '8px', overflow: 'hidden', position: 'relative' }}>
                                            <video style={{ width: '100%', height: '100%', objectFit: 'cover' }}>
                                                <source src={window.URL.createObjectURL(url)} />
                                            </video>
                                            <div style={{ position: 'absolute', bottom: '4px', left: '4px', background: 'rgba(0,0,0,0.6)', borderRadius: '4px', padding: '1px 6px' }}>
                                                <i className="fas fa-play text-white" style={{ fontSize: '10px' }} />
                                            </div>
                                        </div>
                                        : null
                                }
                                <div className="position-absolute" style={{ top: '4px', right: '4px', cursor: 'pointer' }}>
                                    <i className="fas fa-times-circle text-white"
                                        style={{ fontSize: '18px', filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.5))' }}
                                        onClick={() => removeImage(window.URL.createObjectURL(url), index)} />
                                </div>
                                {index === 0 && (
                                    <div className="position-absolute" style={{ top: '4px', left: '4px' }}>
                                        <label style={{ cursor: 'pointer', background: 'rgba(0,0,0,0.6)', borderRadius: '4px', padding: '2px 6px' }}>
                                            <i className="fas fa-plus text-white" style={{ fontSize: '12px' }} />
                                            <input type="file" onChange={uploadHandlerSecondInput}
                                                multiple={true} accept="audio/*,video/*,image/*" style={{ display: 'none' }} />
                                        </label>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}

                {nudityWarning && (
                    <div className="alert alert-warning mt-2" role="alert">
                        {nudityWarning}
                    </div>
                )}

                {/* Hidden file inputs */}
                <input ref={photoInputRef} type="file" onChange={uploadHandler}
                    multiple={true} accept="image/*" style={{ display: 'none' }} />
                <input ref={videoInputRef} type="file" onChange={uploadHandler}
                    multiple={false} accept="video/*" style={{ display: 'none' }} />


              </div>

                {/* Bottom action toolbar — icons left, Post button right */}
                <div style={{
                    borderTop: '1px solid #e4e6eb',
                    padding: '10px 12px',
                    paddingBottom: 'max(10px, env(safe-area-inset-bottom, 10px))',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    background: '#fff',
                    marginLeft: '-16px',
                    marginRight: '-16px',
                    marginBottom: '-16px',
                    marginTop: 'auto',
                    flexShrink: 0,
                }}>
                    <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                        <button type="button" onClick={() => photoInputRef.current?.click()}
                            title="Add Photo"
                            style={{ border: 'none', background: 'none', cursor: 'pointer', width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'background 0.15s' }}
                            onMouseEnter={e => e.currentTarget.style.background = '#f0f2f5'}
                            onMouseLeave={e => e.currentTarget.style.background = 'none'}>
                            <i className="fas fa-image" style={{ fontSize: '20px', color: '#2e9e4f' }} />
                        </button>
                        <button type="button" onClick={() => videoInputRef.current?.click()}
                            title="Add Video"
                            style={{ border: 'none', background: 'none', cursor: 'pointer', width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'background 0.15s' }}
                            onMouseEnter={e => e.currentTarget.style.background = '#f0f2f5'}
                            onMouseLeave={e => e.currentTarget.style.background = 'none'}>
                            <i className="fas fa-video" style={{ fontSize: '20px', color: '#e53935' }} />
                        </button>
                        <button type="button" onClick={() => { /* TODO: audio file picker */ }}
                            title="Add Audio"
                            style={{ border: 'none', background: 'none', cursor: 'pointer', width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'background 0.15s' }}
                            onMouseEnter={e => e.currentTarget.style.background = '#f0f2f5'}
                            onMouseLeave={e => e.currentTarget.style.background = 'none'}>
                            <i className="fas fa-music" style={{ fontSize: '20px', color: '#e56b00' }} />
                        </button>
                        <button type="button" onClick={() => { props.handleShowB(); navigate('/audio-rooms'); }}
                            title="Audio Room"
                            style={{ border: 'none', background: 'none', cursor: 'pointer', width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'background 0.15s' }}
                            onMouseEnter={e => e.currentTarget.style.background = '#f0f2f5'}
                            onMouseLeave={e => e.currentTarget.style.background = 'none'}>
                            <i className="fas fa-microphone" style={{ fontSize: '20px', color: '#8b2fc9' }} />
                        </button>
                        <button type="button" onClick={() => { props.handleShowB(); navigate('/meeting'); }}
                            title="Live Meeting"
                            style={{ border: 'none', background: 'none', cursor: 'pointer', width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', transition: 'background 0.15s' }}
                            onMouseEnter={e => e.currentTarget.style.background = '#f0f2f5'}
                            onMouseLeave={e => e.currentTarget.style.background = 'none'}>
                            <i className="fas fa-video" style={{ fontSize: '20px', color: '#1a6fe0' }} />
                            <span style={{ position: 'absolute', top: '2px', right: '0', background: '#f97316', color: '#fff', fontSize: '7px', fontWeight: 700, borderRadius: '6px', padding: '1px 4px', lineHeight: '1.1' }}>soon</span>
                        </button>
                    </div>
                    <button
                        className="btn btn-primary rounded-pill"
                        onClick={onCreatePost}
                        disabled={isLoading}
                        style={{ fontWeight: 700, padding: '8px 28px', fontSize: '14px', letterSpacing: '0.3px' }}
                    >
                        {isLoading ? (
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                        ) : (
                            t('Post')
                        )}
                    </button>
                </div>
            </ModalBody>
        </Modal>
    </>)
}